/**
 * @generated SignedSource<<fc641293d6ac4058eff5e6bbd44522a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateServiceGroupInput = {
  name?: string | null;
};
export type ServiceGroupEditMainMutation$variables = {
  id: string;
  input: UpdateServiceGroupInput;
};
export type ServiceGroupEditMainMutation$data = {
  readonly updateServiceGroup: {
    readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "ServiceGroupEditTabs_serviceGroup">;
  };
};
export type ServiceGroupEditMainMutation = {
  response: ServiceGroupEditMainMutation$data;
  variables: ServiceGroupEditMainMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ServiceGroupEditMainMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ServiceGroup",
        "kind": "LinkedField",
        "name": "updateServiceGroup",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ServiceGroupEditTabs_serviceGroup"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ServiceGroupEditMainMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ServiceGroup",
        "kind": "LinkedField",
        "name": "updateServiceGroup",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 2147483647
              }
            ],
            "concreteType": "ServiceConnection",
            "kind": "LinkedField",
            "name": "services",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ServiceEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Service",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "price",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deletable",
                            "storageKey": null
                          }
                        ],
                        "type": "Entity",
                        "abstractKey": "__isEntity"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__id",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": "services(first:2147483647)"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "427798af52d7afc97ab392445676b654",
    "id": null,
    "metadata": {},
    "name": "ServiceGroupEditMainMutation",
    "operationKind": "mutation",
    "text": "mutation ServiceGroupEditMainMutation(\n  $id: ID!\n  $input: UpdateServiceGroupInput!\n) {\n  updateServiceGroup(id: $id, input: $input) {\n    ...ServiceGroupEditTabs_serviceGroup\n    ...EntitySidebar_entity\n    id\n  }\n}\n\nfragment AddServiceDialog_serviceGroup on ServiceGroup {\n  id\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment ServiceGroupEditMain_serviceGroup on ServiceGroup {\n  id\n  name\n}\n\nfragment ServiceGroupEditServices_serviceGroup on ServiceGroup {\n  services(first: 2147483647) {\n    edges {\n      node {\n        id\n        ...ServiceRow_service\n      }\n    }\n    pageInfo {\n      ...Table_pageInfo\n    }\n  }\n  ...AddServiceDialog_serviceGroup\n}\n\nfragment ServiceGroupEditTabs_serviceGroup on ServiceGroup {\n  ...ServiceGroupEditMain_serviceGroup\n  ...ServiceGroupEditServices_serviceGroup\n}\n\nfragment ServiceRow_service on Service {\n  id\n  name\n  type\n  price\n  ...SortableEntityTableRow_entity\n}\n\nfragment SortableEntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  ...EntityTableRow_entity\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n"
  }
};
})();

(node as any).hash = "028a4ce5307b47174da663c19c5aae06";

export default node;
